const Content1 = () => {
    return(
        <div className="gradient-policy">
            <h5 className="content1Policy white-text fw-bold fs-30 m-fs-18 lh-160 text-center">Privacy Policy</h5>
        </div>
    )
}

export default Content1